const AboutText = ({ children }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 font-lato">
      {children}
    </div>
  );
};

export default AboutText;
